import React, { useState } from 'react';
import styled from 'styled-components';
import AntdForm, { FormInstance } from 'antd/es/form';
import Button from 'antd/es/button';
import { useHistory } from 'react-router-dom';
import { ValidateErrorEntity } from 'rc-field-form/lib/interface';
import Alert from 'antd/es/alert';
import List from 'antd/es/list';

interface FormProps {
    onSubmit: (formData: unknown) => void;
    onCancel?: () => void;
    form?: FormInstance<unknown>;
    initialValues?: { [key: string]: string };
    children?: React.ReactNode;
    showErrors?: boolean;
    onErrorsFound?: (errors: string[][]) => void;
}
export const Form = ({
    children,
    onSubmit,
    onCancel,
    initialValues,
    form,
    showErrors = true,
    onErrorsFound = () => {},
}: FormProps) => {
    const history = useHistory();
    const [errors, setErrors] = useState<string[][]>([]);
    return (
        <>
            {showErrors && !!errors?.length && <FormErrors errors={errors} />}
            <AntdForm
                form={form}
                name="form"
                layout="vertical"
                initialValues={initialValues}
                autoComplete="off"
                scrollToFirstError={true}
                onFinish={(values: unknown) => onSubmit(values)}
                onFinishFailed={(errorInfo: ValidateErrorEntity<unknown>) => {
                    const submissionErrors = errorInfo.errorFields.map((err) => err.errors);
                    setErrors(submissionErrors);
                    onErrorsFound(submissionErrors);
                }}>
                {children}
                <AntdForm.Item key="btn-group">
                    <BtnGroup>
                        <BackBtn type="primary" onClick={onCancel || (() => history.goBack())}>
                            Cancel
                        </BackBtn>
                        <FormBtn type="primary" htmlType="submit">
                            Save
                        </FormBtn>
                    </BtnGroup>
                </AntdForm.Item>
            </AntdForm>
        </>
    );
};

export const FormErrors = ({ errors }: { errors: string[][] }) => {
    return (
        <Alert
            type="error"
            message="Errors"
            description={
                <List size="small">
                    {errors.map((errorList: any) =>
                        errorList.map((error: any) => <List.Item key={error}>{error}</List.Item>)
                    )}
                </List>
            }></Alert>
    );
};

const BtnGroup = styled.div`
    display: grid;
    grid-template: 'cancel save' auto / max-content max-content;
    grid-gap: ${({ theme }) => theme.spacing.lg};
    justify-content: flex-end;
`;

const FormBtn = styled(Button)`
    padding: inherit ${({ theme }) => theme.spacing.lg};
    border: none;
`;

const BackBtn = styled(FormBtn)`
    background: ${({ theme }) => theme.color.R7};
    &:hover {
        background: ${({ theme }) => theme.color.R9};
    }
`;
